<template>
  <div class="shehui">
    <Menu></Menu>
    <div id="shehui" style="margin-top: 80px;">
		<div class="developmentPlanning-first-screen">
			<img src="../assets/img/shehui.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/shehuiMb.jpg" alt="" class="mbStyle"/>
			<div class="developmentPlanning-first-text">
				<div class="developmentPlanning-first-text1">社会责任</div>
				<div class="developmentPlanning-first-text2">Social responsibility</div>
			</div>
		</div>
		<div class="shehui-second-screen">
			<div class="shehui-second-screen-box">
				<div class="developmentPlanning-first-screen pcStyle">
					<img src="../assets/img/shehui1.jpg" alt="" />
					<div class="developmentPlanning-first-text">
						<div class="developmentPlanning-first-text2">Earth is engulfed by discarded plastics</div>
						<div class="developmentPlanning-first-text1">我们生活的地球，<br/>正在被废弃塑料吞噬</div>
						<div class="developmentPlanning-first-text2">
联合国环境署公布数据显示：全球每分钟卖出约100万个塑料瓶。 每<br/>年约有1300万吨塑料垃圾流入海洋，约有1500万只海洋生物因塑料<br/>垃圾而死亡，塑料在自然环境中分解需450年。</div>
					</div>
				</div>
				<div class="mbStyle">
					<img src="../assets/img/Mb331.jpg" alt="" />
				</div>
				<div class="shehui-second-screen-suliao">
					<div class="shehui-second-screen-suliao-div">
						<div>
							<img src="../assets/img/suliao1.jpg" alt="" />
						</div>
						<div class="shehui-second-screen-suliao-content">
							<div>塑料瓶</div>
							<div class="shehui-second-screen-suliao-text">回收价值较高 回收流程及去向不可追溯</div>
						</div>
					</div>
					<div class="shehui-second-screen-suliao-div">
						<div>
							<img src="../assets/img/suliao2.jpg" alt="" />
						</div>
						<div class="shehui-second-screen-suliao-content">
							<div>洗发水瓶</div>
							<div class="shehui-second-screen-suliao-text">回收价值和回收率低 随意丢弃易造成二次污染</div>
						</div>
					</div>
					<div class="shehui-second-screen-suliao-div">
						<div>
							<img src="../assets/img/suliao3.jpg" alt="" />
						</div>
						<div class="shehui-second-screen-suliao-content">
							<div>玻璃瓶</div>
							<div class="shehui-second-screen-suliao-text">回收价值低，回收率低</div>
						</div>
					</div>
				</div>
				<div class="shehui-second-screen-picture">
					<div class="shehui-second-screen-picture-box">
						<div>
							<img src="../assets/img/pictyue1.jpg" alt="" />
						</div>
						<div>
							<div class="text-font">
								中亚环保举行大型环保公益项目，通过聚合更多人和社会团体的力量，倡导大家一同践行环保，让每一个瓶子安全回家，推动环境的改善。
							</div>
						</div>
					</div>
					<div class="shehui-second-screen-picture-box">
						<div class="pcStyle">
							<div class="text-font" style="margin-top: 10%;">
								中亚环保承办哈尔滨市政府主办的节能环保低碳系列宣传活动。 活动通过组织开展节能环保低碳知识竞赛、低碳达人故事征集、变废为宝创意作品和低碳达人小小环保倡导家评比四大活动，组织社会各界参与节能环保低碳达人秀活动，选拔节能环保领域中的优秀人才，倡导市民在资源节约和环境保护方面从我做起、积极实践，共同带动全社会应对大气污染防治、推动节能减排工作，建设美丽哈尔滨。 宣传覆盖范围达到了1000余万人次，并且参与到各项系列活动当中来的市民已超过60万人次。
							</div>		
						</div>
						<div>
							<img src="../assets/img/pictyue2.jpg" alt="" />
						</div>
						<div class="mbStyle">
							<div class="text-font" style="margin-top: 10%;">
								中亚环保承办哈尔滨市政府主办的节能环保低碳系列宣传活动。 活动通过组织开展节能环保低碳知识竞赛、低碳达人故事征集、变废为宝创意作品和低碳达人小小环保倡导家评比四大活动，组织社会各界参与节能环保低碳达人秀活动，选拔节能环保领域中的优秀人才，倡导市民在资源节约和环境保护方面从我做起、积极实践，共同带动全社会应对大气污染防治、推动节能减排工作，建设美丽哈尔滨。 宣传覆盖范围达到了1000余万人次，并且参与到各项系列活动当中来的市民已超过60万人次。
							</div>		
						</div>
					</div>
					<div class="shehui-second-screen-picture-box">
						<div>
							<img src="../assets/img/pictyue3.jpg" alt="" />
						</div>
						<div>
							<div class="text-font" style="margin-top: 14%;">
								中亚环保在国内持续推动环保公益教育，走进中央直属机关单位、哈尔滨市中小学、高校、机构、社区等，与超过10万人分享可持续环保理念并号召更多人加入行动、践行环保。
								
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'shehui',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/socialResponsibility.scss';

</style>


// WEBPACK FOOTER //
// src/components/socialResponsibility.vue